import { render, staticRenderFns } from "./updateManager.vue?vue&type=template&id=a24dcd38&scoped=true&"
import script from "./updateManager.vue?vue&type=script&lang=js&"
export * from "./updateManager.vue?vue&type=script&lang=js&"
import style0 from "./updateManager.vue?vue&type=style&index=0&id=a24dcd38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24dcd38",
  null
  
)

export default component.exports